import React from 'react'

import { Button } from 'reactstrap';

const PermisssionFilter = ({onClickFilterCallback}) => {
    const [keyword, setKeyword] = React.useState('')
    
    const onKeywordChange = (e) => {
        setKeyword( e.target.value)
    }
    
    const onClickFilter = (event, reset= false) => {
        event.preventDefault();
        if(reset){     
            setKeyword('')   
            onClickFilterCallback('')
        }else{
            onClickFilterCallback(keyword)
        }
    }

    return (
        <form className="form__form-group" onSubmit={onClickFilter}>
            <div className="col-md-4">
                <div className="">
                    <input 
                        value={keyword}
                        onChange={onKeywordChange}
                        type="text"
                        placeholder="Search by ID or name"
                    />
                </div>
            </div>
            <div className="col-md-4  pl-0">
                <p className="">&nbsp;</p>
                <div className='flex'>

                    <Button
                        type='submit'
                        className="btn btn-sm btn-primary"
                        color="#ffffff"
                    
                    >   
                        Filter
                    </Button>
                    <Button
                        onClick={(e)=>onClickFilter(e,true)}
                        className="btn btn-sm btn-secondary"
                        color="#ffffff"
                    >
                        Reset
                    </Button>
                </div>
                
            </div>
        </form>
    )
}

export default PermisssionFilter;